/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Creator_Checkout_Verification_Failed_TextInputs */

const en_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to verify your subscription. Please contact ${i?.email} for assistance.`)
};

const fr_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de verifier votre abonnement. Veuillez contacter ${i?.email} pour assistance.`)
};

const de_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement konnte nicht verifiziert werden. Bitte kontaktieren Sie ${i?.email} für Unterstützung.`)
};

const it_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile verificare l'abbonamento. Contattare ${i?.email} per assistenza.`)
};

const ru_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось подтвердить вашу подписку. Пожалуйста, свяжитесь с ${i?.email} для получения помощи.`)
};

const es_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo verificar su suscripción. Para obtener ayuda, contacte con ${i?.email}.`)
};

const zh_cn2_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法验证您的订阅。请联系${i?.email}寻求帮助。`)
};

const ja_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サブスクリプションを確認できません。${i?.email} までお問い合わせください。`)
};

const hi_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपकी सदस्यता सत्यापित नहीं हो पा रही है। कृपया सहायता के लिए ${i?.email} से संपर्क करें।`)
};

const pt_pt2_creator_checkout_verification_failed_text = /** @type {(inputs: Creator_Checkout_Verification_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível verificar sua assinatura. Entre em contato com ${i?.email} para obter assistência.`)
};

/**
* | output |
* | --- |
* | "Unable to verify your subscription. Please contact {email} for assistance." |
*
* @param {Creator_Checkout_Verification_Failed_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verification_failed_text = /** @type {((inputs: Creator_Checkout_Verification_Failed_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verification_Failed_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_verification_failed_text(inputs)
	if (locale === "de") return de_creator_checkout_verification_failed_text(inputs)
	if (locale === "it") return it_creator_checkout_verification_failed_text(inputs)
	if (locale === "ru") return ru_creator_checkout_verification_failed_text(inputs)
	if (locale === "es") return es_creator_checkout_verification_failed_text(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_verification_failed_text(inputs)
	if (locale === "ja") return ja_creator_checkout_verification_failed_text(inputs)
	if (locale === "hi") return hi_creator_checkout_verification_failed_text(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_verification_failed_text(inputs)
	return en_creator_checkout_verification_failed_text(inputs)
});